import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'

import SignInForm from '../signin/SignInForm'
import SignUpForm from '../signin/SignUpForm'
import SignInHeader from '../signin/SignInHeader'
import Layout from '../shared/Layout'
import { ALMOST_WHITE } from '../styles'
import {
  callGoogleLogin,
  logout,
  signInByEmailPassword,
  signUp
} from 'controllers/auth'

const Container = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: relative;
  background: ${ALMOST_WHITE};
`

class SignIn extends Component {
  state = {
    isSignInMode: true
  }

  handleGoogleSignIn = () => this.props.dispatch(callGoogleLogin())
  handleLogoutClick = () => this.props.dispatch(logout())

  handleSignIn = (values) => {
    this.props.dispatch(signInByEmailPassword(values))
  }

  handleSignUp = (values) => {
    this.props.dispatch(signUp(values))
  }

  renderSignUp = () => {
    return (
      <SignUpForm handleSignUp={this.handleSignUp} />
    )
  }

  renderSignIn = () => {
    return (
      <SignInForm
        handleGoogleSignIn={this.handleGoogleSignIn}
        handleSignIn={this.handleSignIn}
      />
    )
  }

  renderHeader () {
    const toggleSignInMode = () => {
      this.setState({isSignInMode: !this.state.isSignInMode})
    }

    return (
      <SignInHeader
        isSignInMode={this.state.isSignInMode}
        toggleSignInMode={toggleSignInMode}
      />
    )
  }

  renderMain () {
    let form

    if (this.state.isSignInMode) {
      form = this.renderSignIn()
    } else {
      form = this.renderSignUp()
    }

    return <Container>{form}</Container>
  }

  render () {
    return (
      <Layout
        header={this.renderHeader()}
        main={this.renderMain()}
      />
    )
  }
}

SignIn.propTypes = {
  // form: PropTypes.object.isRequired,
  // authData: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  // authData: state.authData
})

export default connect(mapStateToProps)(SignIn)



// WEBPACK FOOTER //
// ./src/components/pages/SignIn.js